import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "entryCheck";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    //查询入境登记单
    async getEntryCheckData({ commit }, payload) {
      let result = await api.get(
        `/api/EntryCheck?${queryString.stringify(payload)}`
      );
      return result.data;
    },

    //新增入境登记单
    async addEntryCheck(a, payload) {
      let result = await api.post("/api/EntryCheck", payload);
      return result.data;
    },
    //删除整个入境登记单
    async delEntryCheckAll(a, payload) {
      let result = await api.delete(`/api/EntryCheck/` + payload);
      return result;
    },
    //删除单行数据
    async delEntryCheck(a, payload) {
      let result = await api.delete(`/api/EntryCheck/Detail/` + payload);
      return result;
    },
    //获取入境登记单-单条
    async getEditEntryCheck(a, payload) {
      let result = await api.get(`/api/EntryCheck/` + payload);
      return result.data;
    },
    //修改入境登记单
    async updateEntryCheck(a, payload) {
      let result = await api.put(`/api/EntryCheck`, payload);
      return result.data;
    },
  },
  // mutations: {
  //   setExpenseRecordList(state, payload) {
  //     state.expenseRecordList = payload;
  //   }
  // },
  getters: {},
});

export default moduleName;
